export default __webpack_public_path__ + "static/media/image6.cf9d0495.png";